import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import BackToTopButton from "../BackToTopButton";
import Footer from "./Footer";
import LogoutAlert from "../auth/LogoutAlert";

const Layout = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  // Handle the back navigation logic
  const handleBackNavigation = (event) => {
    // Check if we're at the start of the history stack (no previous route)
    if (window.history.length <= 1) {
      event.preventDefault();
      setShowLogoutModal(true);
    }
  };

  // Handle logout action
  const handleLogout = () => {
    setShowLogoutModal(false);
    navigate("/login");
  };

  // Handle cancel logout action (close modal)
  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  // Listen to the browser back button (popstate event)
  useEffect(() => {
    const preventBack = (event) => {
      if (window.history.length <= 1) {
        event.preventDefault();
        setShowLogoutModal(true);
      }
    };

    // Add event listener for popstate on component mount
    window.addEventListener("popstate", preventBack);

    // Push a state to ensure the user can't go back
    window.history.pushState(null, document.title);

    return () => {
      // Clean up the event listener on component unmount
      window.removeEventListener("popstate", preventBack);
    };
  }, []);

  return (
    <div className="wrapper">
      <Navbar />
      <Breadcrumb />
      <div className="content">
        <Outlet />
      </div>
      <BackToTopButton />
      <Footer />

      {/* Show Logout Modal */}
      {showLogoutModal && (
        <LogoutAlert
          message="You will be logged out if you leave this page."
          onLogout={handleLogout}
          onCancel={handleCancelLogout}
        />
      )}
    </div>
  );
};

export default Layout;
